import React, { useState } from "react";
import styles from "../courier/OrderRow.module.scss";
import EyeIcon from "../../../assets/images/courier/Eye (1).svg";
import editBtn from "../../../assets/images/otp/Frame 2087326387 (1).svg";
import { formatDate } from "../../../extentions/date";
import DetailModal from "../../shared/detailModal/DetailModal";
import NewModal from "../../shared/newModal/NewModal";
import { CourierServices } from "../../../services/courier.service";
import EyeImg from "../../../assets/images/courier/Eye (1).svg";
import { WoltService } from "../../../services/wolt.service";

export interface WoltOrderRowProps {
  id: number;
  client_id: number;
  total_amount: string;
  address: string;
  customer: string;
  phone: string;
  client_name: string;
  status_name: string;
  order_date: string;
  time_interval?: string;
  wolt_tracking?: string;
  setLoading?: (value: boolean) => void;
  data?: any; // translation or shared text data
}

const WoltOrderRow: React.FC<WoltOrderRowProps> = ({
  id,
  client_id,
  total_amount,
  address,
  customer,
  phone,
  status_name,
  order_date,
  time_interval,
  wolt_tracking,
  setLoading,
  data,
}) => {
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [detailData, setDetailData] = useState<any>(null);
  const [loadingDetail, setLoadingDetail] = useState(false);

  const handleShowDetailModal = async (orderId: number) => {
    setLoadingDetail(true);
    const { data, status } = await WoltService.getWoltOrderDetails(orderId);
    setLoadingDetail(false);
    if (status === 200) {
      setDetailData(data.packages);
      setShowDetailModal(true);
    }
  };

  return (
    <>
      <tr className={styles.WebTable_body}>
        <td>{customer}</td>
        <td>{time_interval || "-"}</td>
        <td>{phone}</td>
        <td>
          <p style={{ backgroundColor: status_name }} className={styles.status}>
            {status_name}
          </p>
        </td>
        <td>
          {total_amount} <span style={{ marginLeft: "10px" }}>AZN</span>
        </td>
        <td>{address}</td>
        <td>
          {wolt_tracking ? (
            <a
              href={wolt_tracking}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.trackingLink}
            >
              {data?.wolt_track || "İzlə"}
            </a>
          ) : (
            "-"
          )}
        </td>
        <td>
          <img
            src={EyeImg}
            alt=""
            onClick={() => handleShowDetailModal(id)}
            style={{ cursor: "pointer" }}
          />
        </td>
      </tr>

      {showDetailModal && detailData && (
        <DetailModal
          title=""
          content="Bağlama Detalları"
          onClose={() => setShowDetailModal(false)}
          musteriId={id}
          orderData={detailData}
          setShowModal={setShowDetailModal}
        />
      )}

      {showModal && (
        <NewModal
          title=""
          content={data?.switch_account_confirm}
          onClose={() => setShowModal(false)}
          confirmText={data?.auth_logout_yes}
          cancelText={data?.auth_logout_no}
          musteriId={id}
          setShowModal={setShowModal}
          setLoading={setLoading ?? (() => {})}
        />
      )}
    </>
  );
};

export default WoltOrderRow;
